import React, { useEffect, useState } from 'react';

// import '@ant-design/compatible/assets/index.css';


import {
  Col,
  Row,
  DatePicker,
  FormInstance,
  Form,
  Badge,
  Typography,
  Tag,
  Spin,
} from 'antd';
import { PhoneFilled, HomeFilled, MailFilled } from '@ant-design/icons';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import TextArea from 'antd/lib/input/TextArea';
import moment from 'moment';
import { useModalState } from 'hooks/useModalState';
import { CIListResponse } from 'services/clientInvoice';
import ParListSelect from 'components/ParListSelect';
import DocList from 'pages/Document/DocList';
import { toCurrency } from 'utils/utils';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import ModalControllerNV from 'components/ModalControllerNV';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import { useQuery } from 'react-query';
import { getCollectionByColid } from 'services/collection';
import { isNil, sumBy } from 'lodash';
import InputCurrency from 'components/InputCurrency';
import UtinaCard from 'components/UtinaCard';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Value from 'components/Value';
import StatusHistoryPopover from 'components/StatusHistoryPopover';
import { shouldUpdateCompare } from 'utils/utils2';
import Managermodal from 'pages/Collection/CollectionDetail/components/managermodal';
import ThirdPartyInput from 'components/ThirdPartyInput';
import AddresseListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/AddressesListSelect';

export type tabCreatePromiseProps = {
  form?: FormInstance;
  objectid: number;
  object: string;
  dataInput?: any;
  setSuccessful?: any;
};

const TabCreatePromise = ({
  objectid,
  object,
  form,
  dataInput,
  setSuccessful,
}: tabCreatePromiseProps) => {
  form?.setFieldsValue({
    promcreationdate: moment(),
    promstatus: 'ACTIVE',
    promstatusdate: moment(),
  });

  if (dataInput) {
    form?.setFieldsValue({
      totalunpaid: toCurrency(
        dataInput?.totalunpaid,
        dataInput?.currcode ?? localStorage.getItem('currcode') ?? ''
      ),
    });
  }

  const [clientinvoice, setclientinvoice] = useState<
    CIListResponse | undefined
  >();

  const { close: closemodal, open: openmodal, visible } = useModalState();
  const [searchParams] = useState<any>({
    objectid: objectid,
  });

  const onClientInvoiceSelect = (selectedInvoice: CIListResponse) => {
    form?.setFieldsValue({ objectid: selectedInvoice.ciid });
    setclientinvoice(selectedInvoice);
    form?.setFieldsValue({
      ciid: selectedInvoice.ciid,
      clientinvoice: selectedInvoice.cireference,
    });

    // searchParamTaskLists.objectid = selectedInvoice.ciid;

    closemodal();
  };
  const {
    data: collection,
    refetch,
    isFetching,
  } = useQuery(
    ['getCollectionByColid', objectid],
    () =>
      getCollectionByColid({ colid: objectid! }).then((res) => res.data || {}),
    {
      enabled: !isNil(objectid),
    }
  );

  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  useEffect(() => {
    if (collection) {
      form?.setFieldsValue({
        ...collection,
        thirdparty: {
          tpid: collection.tpidclient,
          tpreference: collection.tpreference,
          tpname: collection.tpname,
        },
        totalOwes: collection.totaloutstanding + collection.totalunpaid,
      });
    }
  }, [collection]);
  const columnsUnpaid: DataGridColDef<any>[] = [
    {
      dataIndex: 'cireference',
      width: '20%',
      render: (value, record) => (
        <ModalControllerNV
          content={({ setVisible, visible }) => (
            <a onClick={() => setVisible(true)}>{record.cireference}</a>
          )}
          modal={({ setVisible, visible }) => (
            <CIDetail
              ciid={Number(record.ciid)}
              onCancel={() => setVisible(false)}
              showAsModal
              visible={visible}
              isCreateCI={false}
              showButtons={false}
            />
          )}
        />
      ),
    },
    {
      dataIndex: 'cisorder',
      key: 'cisorder',
      width: '10%',
    },
    {
      dataIndex: 'cistatuslable',
      width: '20%',
    },
    {
      dataIndex: 'cidocdate',
      width: '20%',
    },
    {
      dataIndex: 'civaluedate',
      width: '20%',
    },
    {
      dataIndex: 'cigrosstotal',
      width: '10%',
      render: (value, record) => toCurrency(value, record.currcode),
      align: 'right',
    },
    {
      dataIndex: 'cisunpaidamount',
      render: (value, record) => toCurrency(value, record.currcode),
      width: '20%',
      align: 'right',
    },
  ];

  return (
    <DF.Provider pagcode="TabCreatePromise" entity={object} entityid={objectid}>
      <Spin spinning={isFetching}>
        <Row gutter={32}>
          <Col span={14}>
            <Row>
              <UtinaCard
                style={{ height: '100%' }}
                level={5}
                lg={24}
                comcode="general_Information"
                styleCard={{
                  paddingRight: 0,
                  paddingTop: '5px',
                  backgroundColor: 'rgba(240, 240, 240,0.3)',
                }}
              >
                <Badge.Ribbon
                  style={{ fontSize: '15px' }}
                  text={
                    <div>
                      {collection ? (
                        <Typography.Text strong style={{ color: 'white' }}>
                          {collection?.unpaidnbreofdays + '   '}
                          <GetLabel label="days" />
                        </Typography.Text>
                      ) : (
                        ''
                      )}
                    </div>
                  }
                  color="#f4a261"
                >
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={18}>
                      <Row>
                        <FormInput
                          col
                          md={12}
                          initialValue={2232}
                          name="colreference"
                          noMargin
                        >
                          <Value />
                        </FormInput>
                        <StatusHistoryPopover
                          objectid={objectid ? objectid : (null as any)}
                          entity="COLLECTION"
                        >
                          <Col span={12} style={{ marginTop: '8px' }}>
                            {collection ? (
                              <Tag
                                color="#cd201f"
                                style={{
                                  fontSize: '15px',
                                }}
                              >
                                {collection?.colstatusLabel +
                                  ' - ' +
                                  collection?.colstatusdate}
                              </Tag>
                            ) : (
                              ''
                            )}
                          </Col>
                        </StatusHistoryPopover>
                      </Row>
                    </Col>
                  </Row>
                </Badge.Ribbon>
                <Badge.Ribbon
                  style={{ fontSize: '15px' }}
                  text={
                    <div>
                      <Typography.Text strong style={{ color: 'white' }}>
                        {toCurrency(
                          collection?.totalunpaid,
                          localStorage.getItem('currcode') ?? ''
                        )}
                      </Typography.Text>
                    </div>
                  }
                  color="#e76f51"
                >
                  <Row>
                    <Col span={18}>
                      <Row>
                        <FormInput noMargin col md={12} name="colstartdate">
                          <Value />
                        </FormInput>
                        <FormInput noMargin col md={12} name="colenddate">
                          <Value />
                        </FormInput>
                        <Form.Item
                          shouldUpdate={shouldUpdateCompare('colmanagerName')}
                          noStyle
                        >
                          {({ getFieldValue }) => (
                            <FormInput
                              noMargin
                              col
                              md={12}
                              name="colmanagerName"
                            >
                              <Managermodal
                                colid={objectid!}
                                managername={getFieldValue('colmanagerName')}
                              />
                            </FormInput>
                          )}
                        </Form.Item>

                        <FormInput noMargin col md={12} name="colassigndate">
                          <Value />
                        </FormInput>
                      </Row>
                    </Col>
                  </Row>
                </Badge.Ribbon>
              </UtinaCard>
            </Row>
            <Row>
              <Col span={24}>
                <DataGrid
                  titleComcode="liste_unpaid"
                  columns={columnsUnpaid}
                  dataSource={collection?.colunpaidList || []}
                  rowKey="cunpid"
                  rowSelection={{
                    type: 'checkbox',
                    onChange: (selectedrowkeys: any, selectedrows: any[]) => {
                      form?.setFieldsValue({
                        promamount: sumBy(selectedrows, 'cisunpaidamount'),
                      });
                      let comment = '';
                      selectedrows.forEach((row) => {
                        comment = comment + row.cireference + ' \n ';
                      });
                      form?.setFieldValue('promcomment', comment);
                    },
                  }}
                  scroll={{ x: 1200, y: 150 }}
                  pagination={{ pageSize: 100, hideOnSinglePage: true }}
                  hideExtraAction
                  hideFilters
                />
              </Col>
            </Row>
          </Col>

          <Col span={9}>
            <Row>
              <UtinaCard
                level={5}
                lg={24}
                comcode="personalInfo"
                styleCard={{ backgroundColor: 'rgba(240, 240, 240,0.3)' }}
              >
                <FormInput noMargin col md={24} name="thirdparty">
                  <ThirdPartyInput display />
                </FormInput>

                <Form.Item
                  shouldUpdate={shouldUpdateCompare('tpidclient')}
                  noStyle
                >
                  {({ getFieldValue }) => (
                    <FormInput
                      icon={
                        <HomeFilled style={{ color: 'red', fontSize: 15 }} />
                      }
                      noMargin
                      col
                      md={24}
                      name="tpadrid"
                    >
                      <AddresseListSelect
                        params={{ tpid: getFieldValue('tpidclient') }}
                        display
                      />
                    </FormInput>
                  )}
                </Form.Item>
                <FormInput
                  noMargin
                  icon={
                    <PhoneFilled style={{ color: '#008F41', fontSize: 15 }} />
                  }
                  col
                  md={24}
                  name="tptel1"
                >
                  <Value />
                </FormInput>
                <FormInput
                  icon={<MailFilled style={{ color: 'black', fontSize: 15 }} />}
                  noMargin
                  col
                  md={24}
                  name="tpemail"
                >
                  <Value />
                </FormInput>

                <FormInput noMargin col md={24} name="tpsalestatuslabel">
                  <Value />
                </FormInput>

                {/* <FormInput noMargin col md={24} name="totalunpaid">
                        <Value formatter={(val) => toCurrency(val, localStorage.getItem('currcode') ?? '')} />
                      </FormInput> */}
                <FormInput noMargin col md={24} name="totaloutstanding">
                  <Value
                    formatter={(val) =>
                      toCurrency(val, localStorage.getItem('currcode') ?? '')
                    }
                  />
                </FormInput>
              </UtinaCard>
            </Row>
            <Row>
              <UtinaCard
                level={5}
                lg={24}
                comcode="prom"
                styleCard={{ backgroundColor: 'rgba(240, 240, 240,0.3)' }}
              >
                <Row gutter={16}>
                  <FormInput
                    col
                    md={12}
                    name="promtype"
                    rules={[{ required: true }]}
                  >
                    <ParListSelect parcode="PROMISTYPE" />
                  </FormInput>

                  <FormInput col md={12} name="upload">
                    <DocList
                      objectid={objectid}
                      objecttype="COLLECTION"
                      tpid={collection?.tpidclient}
                      categorie="DOC"
                      showBtn
                    />
                  </FormInput>
                </Row>
                <Row gutter={16}>
                  <FormInput
                    name="promdate"
                    col
                    md={10}
                    rules={[{ required: true }]}
                  >
                    <DatePicker />
                  </FormInput>
                  <FormInput
                    name="promamount"
                    col
                    md={11}
                    rules={[{ required: true }]}
                  >
                    <InputCurrency
                      currcode={
                        collection?.currcode ??
                        localStorage.getItem('currcode') ??
                        ''
                      }
                      min={0}
                    />
                  </FormInput>
                </Row>
              </UtinaCard>
            </Row>
          </Col>
          {/* <FormInput col md={8} name="clientinvoice">
                <UnpaidClientInvoiceInput
                  onChange={onClientInvoiceSelect}
                  colid={searchParams.objectid}
                  onClear={() => {
                    setclientinvoice(undefined);
                  }}
                />
              </FormInput>
              <Col span={8}></Col> */}

          {/* <Row gutter={30}>
              <Col span={8}></Col>
              {clientinvoice && (
                <>
                  <FormInput
                    col
                    md={8}
                    name="duedate"
                    initialValue={clientinvoice?.cidocdate}
                  >
                    <h3
                      color="#cd201f"
                      style={{
                        fontWeight: 'bold',
                        fontSize: '14px',
                      }}
                    >
                      {clientinvoice?.cidocdate}
                    </h3>
                  </FormInput>

                  <FormInput
                    wrapperCol={{ span: 8 }}
                    name="totalunpaid"
                    col
                    md={8}
                  >
                    <Tag
                      color="#cd201f"
                      style={{
                        fontWeight: 'bold',
                        fontSize: '15px',
                      }}
                    >
                      {toCurrency(
                        clientinvoice?.cigrosstotal,
                        clientinvoice?.currcode
                      )}
                    </Tag>
                  </FormInput>
                </>
              )}
            </Row> */}
        </Row>

        <Row>
          <FormInput name="promcomment" rules={[{ required: true }]}>
            <TextArea maxLength={255} rows={5} cols={300} />
          </FormInput>
        </Row>
        {/* <UnpaidClientListModal
        visible={visible}
        colid={objectid!}
        onCancel={closemodal}
        hideCol
        hideExtraAction={() => true}
        rowSelection={{
          renderCell: (value: boolean, record: any) => (
            <CheckSquareTwoTone onClick={() => onClientInvoiceSelect(record)} />
          ),
          hideSelectAll: true,
        }}
      /> */}
      </Spin>
    </DF.Provider>
  );
};
export default TabCreatePromise;
